import { CSSObject } from '@chakra-ui/react';

export const Wrapper: CSSObject = {
  h: ['50px', null, '40px'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'body',
};

export const TextItem: CSSObject = {
  color: 'white',
  textAlign: 'center',
  fontSize: 'sm',
  fontWeight: 'normal',
  textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
};

export const LinkItem: CSSObject = {
  color: 'beta.300',
  fontWeight: 'bold',
  fontSize: 'sm',
  textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
};
